import { useTranslation } from 'react-i18next';

export default function ScholarCard({ scholar, onOpen, isMine }) {
  const { t } = useTranslation();
  const location = [scholar.city, scholar.country].filter(Boolean).join(', ');

  return (
    <button
      type="button"
      onClick={() => onOpen(scholar)}
      className="card flex w-full flex-col items-start gap-2 text-left"
    >
      <div className="flex w-full items-baseline justify-between gap-3">
        <h3 className="font-serif text-xl font-semibold text-cream">{scholar.name}</h3>
        {isMine && (
          <span className="rounded-full border border-gold/40 bg-navy-mid/40 px-2 py-0.5 text-[0.65rem] uppercase tracking-[0.12em] text-gold-light">
            {t('scholars.you')}
          </span>
        )}
      </div>
      {scholar.position && (
        <p className="text-sm text-ink-secondary">{scholar.position}</p>
      )}
      {scholar.university && (
        <p className="text-sm text-ink-secondary">
          {scholar.department ? `${scholar.department}, ` : ''}
          <span className="text-cream/80">{scholar.university}</span>
        </p>
      )}
      {location && (
        <p className="mt-1 text-xs uppercase tracking-[0.12em] text-ink-muted">{location}</p>
      )}
    </button>
  );
}
